//接口文件
//引入配置接口文件
import axios from "./config"

//登入接口
export const login = (username, password) => axios({
    //请求头，请求体json默认不写
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: "/subLogin",
    method: "post",
    //请求头传值方式
    data: "username=" + username + "&password=" + password,
    //请求体传值方式,json格式
    // data: {username,password}
})

export const get_sts = () => axios({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: '/sts/get?appId=' + '208234456990' + "&appSecret=" + 'asdf98013435434ddff',
    method: "get",
})

//云服务首页
//获取云服务表格信息
export const cloud_config_tabledata = (page) => axios({
    url: "/cloud/config/pageList",
    method: "post",
    data: {
        page
    }
})


//云服务新增表格信息
export const addCloudInfo = (cloudForm) => axios({
    url: "/cloud/config/add",
    method: "post",
    data: cloudForm
})


//云服务修改信息
export const editCloudInfo = (cloudForm) => axios({
    url: "/cloud/config/update",
    method: "post",
    data: cloudForm
})


//云服务删除信息
export const delCloudInfo = (id) => axios({
    //请求头，请求体json默认不写
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: "/cloud/config/delete",
    method: "post",
    //请求头传值方式
    data: "id=" + id,
    //请求体传值方式,json格式
    // data: {username,password}
})


//项目管理
//获取项目管理表格信息
export const projectInfo = (cloudConfigId,page,that,projectName) => axios({//that
    url: "/project/pageList",
    method: "post",
    data: {
        "cloudConfigId": cloudConfigId,
        "page": page,
        'projectName': projectName
    },
    timeout: 2000,
    cancelToken: new axios.CancelToken(function executor(c) { // 设置 cancel token
      that.source = c;
    })    
})


//项目管理新增项目
export const addProjectInfo = (projectForm) => axios({
    url: "/project/add",
    method: "post",
    data: projectForm
})


//项目管理修改项目
export const editProjectInfo = (projectForm) => axios({
    url: '/project/updateProject',
    method: 'post',
    data: projectForm
})


//项目管理删除项目
export const  delProjectInfo = (cloudId,id) => axios({
    //请求头，请求体json默认不写
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: '/project/deleteProject',
    method: 'post',
    data: 'cloudId='+cloudId+'&id='+id
})


//项目查看表格
export const viewProjectInfo = (id,projectForm) => axios({
    //请求头，请求体json默认不写
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: "/project/getInfo",
    method: "post",
    //请求头传值方式
    data: "projectId=" + id + "&cloudConfigId=" + projectForm.id,
    //请求体传值方式,json格式
    // data: {username,password}
})


//云服务列表
export const cloudSelectInfo = () => axios({
    url: "/cloud/config/pageList",
    method: "post",
    data: {}
})


//获取省市二级列表数据
export const getProvinceCities = () => axios({
    url: '/region/getProvinceCities1',
    method: 'post',
    data: {}
})


//代理商列表中获取所有的代理商名称
export const cloudCompany = (cloudConfigId) => axios({
    url: '/company/pageList',
    method: 'post',
    data: {
        cloudConfigId: cloudConfigId
    }
})


//代理商管理
//获取代理商管理表格信息
export const agentInfo = (companyName,contactName,mobile,page={}) => axios({
    url: "/company/pageList",
    method: "post",
    data: {
        "companyName": "",
        "contactName": "",
        "mobile": "",
        "page": page,
    }
})


//代理商管理新增表格信息
export const addAgentInfo = (AgentForm) => axios({
    url: "/company/add",
    method: "post",
    data: {
        "address": AgentForm.address,
        "cloudConfigId": AgentForm.checkedClouds.toString(),
        "companyName": AgentForm.companyName,
        "contactName": AgentForm.contactName,
        "mobile": AgentForm.mobile,
        "logo": AgentForm.logo,
    }
})


//删除代理商信息
export const delAgentInfo = (id) => axios({
    //请求头，请求体json默认不写
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: "/company/delete",
    method: "post",
    //请求头传值方式
    data: "id=" + id,
    //请求体传值方式,json格式
    // data: {username,password}
})


//修改代理商表格信息
export const editAgentInfo = (AgentForm) => axios({
    url: "/company/update",
    method: "post",
    data: {
        "cloudConfigId": AgentForm.checkedClouds.toString(),
        "companyName": AgentForm.companyName,
        "contactName": AgentForm.contactName,
        "mobile": AgentForm.mobile,
        "id": AgentForm.id,
        "logo": AgentForm.logo,
    }
})


//获取云服务多选代理商信息
export const cloudCheckbox = () => axios({
    url: "/cloud/config/pageList",
    method: "post",
    data: {}
})


//用户管理
// 获取用户管理表格信息
export const userInfo = (userName, nickName, mobile,companyId,userType,page={}) => axios({
    url: "/usermanage/userPageList",
    method: "post",
    data: {
        "userName": userName,
        "nickName": nickName,
        "mobile": mobile,
        "companyId": companyId,
        "userType": userType,
        "page": page

    }
})


//用户管理新增表格信息
export const addUserInfo = (userForm) => axios({
    url: "/usermanage/addUserInfo",
    method: "post",
    data: userForm
})


//修改用户表格信息
export const editUserInfo = (userForm) => axios({
    url: "/usermanage/updateUserInfo",
    method: "post",
    data: {
        "id": userForm.id,
        "email": "",
        "logo": "",
        "mobile": userForm.mobile,
        "nickName": userForm.nickName,
        "companyId":userForm.companyId,
        "userType": userForm.userType,
        "userName":userForm.userName
    }
})


//用户删除信息
export const delUserInfo = (id) => axios({
    //请求头，请求体json默认不写
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: "/usermanage/deleteUser",
    method: "post",
    //请求头传值方式
    data: "id=" + id,
    //请求体传值方式,json格式
    // data: {username,password}
})


//获取代理商的公司列表
export const selectInfo = () => axios({
    url: "/company/pageList",
    method: "post",
    data: {}
})

//根据代理商id查看云管理
export const cloudConfigsTabs = (id) =>axios({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: "/company/getInfo",
    method: "post",
    //请求头传值方式
    data: "id=" + id,
})

//根据代理商名称和云管理id查看项目列表
export const grantProjects = (data) => axios({
    url: "/project/pageList",
    method: 'post',
    data: data
})

//授权用户项目
export const authorizationUserProject = (data) => axios({
    url: '/usermanage/authorizationUserProject',
    method: 'post',
    data: data
})

//查询用户所有项目
export const viewAuthorizedProjects = (id) => axios({
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    url: '/app/usermanage/findUserProject',
    method: "post",
    params: {
        userId: id
    }
})

//设备库
// 设备库上传文件
export const eqiup_upload = (form,file) => axios({
    // headers: {
    //     'Content-Type': 'multipart/form-data'
    // },
    url: '/cloudDeviceMeta/add',
    method: 'post',
    data:{
        'cloudConfigId': form.cloudConfigId,
        'memo': form.memo,
        'file': file,
    }
    //'cloudConfigId='+ form.cloudConfigId + '&file=' + file + "&memo=" + form.memo  
})

//设备分页列表
export const eqiup_page = (cloudConfigId,page,that) => axios({
    url: '/cloudDeviceMeta/page',
    method: 'post',
    data: {
        'cloudConfigId': cloudConfigId,
        'page': page
    },
    timeout:2000,
    cancelToken: new axios.CancelToken(function executor(c) { // 设置 cancel token
      that.source = c;
    }) 
})

//启用
export const enabled = (cloudConfigId,id) => axios({
    url: '/cloudDeviceMeta/enableVersionData',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'post',
    data: 'cloudConfigId=' + cloudConfigId + '&id=' + id
})

//模型管理
//模型分页列表
export const modelManage_page = (cloudConfigId,page) => axios({
    url: '/model/pageList',
    method: 'post',
    data: {
        'cloudConfigId': cloudConfigId,
        'page': page
    }
})

//新增模型
export const addModelManage = (cloudConfigId,form) => axios({
    url: '/model/add',
    method: 'post',
    data: {
        "cloudConfigId": cloudConfigId,
        "commandProperties": form.commandProperties,
        "modelName": form.modelName,
        "statusProperties": form.statusProperties,
        "deviceType": form.deviceType,
        "protocolType": form.protocolType,
        "category": form.category,
    }
})

//删除模型
export const delModelManage = (cloudConfigId,id) => axios({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: '/model/delete',
    method: 'post',
    data: 'cloudConfigId=' + cloudConfigId + '&id=' + id
})


//修改模型
export const editModelManage = (cloudConfigId,form,id) => axios({
    url: '/model/update',
    method: 'post',
    data: {
        "cloudConfigId": cloudConfigId,
        "commandProperties": form.commandProperties,
        "modelName": form.modelName,
        "statusProperties": form.statusProperties,
        "deviceType": form.deviceType,
        "protocolType": form.protocolType,
        "category": form.category,
        'id': id,
    }
})

//模型设备管理
//表格
export const modelEquip_page = (cloudConfigId,page) => axios({
    url: '/model/device/pageList',
    method: 'post',
    data: {
        'cloudConfigId': cloudConfigId,
        'page': page
    }
})

//新增数据
export const add_modelEquip = (cloudConfigId,form) => axios({
    url: '/model/device/add',
    method: 'post',
    data: {
        "cloudConfigId": cloudConfigId,
        "deviceName": form.deviceName,
        "deviceTypeNo": form.deviceTypeNo,
        "modelPortDtoList": form.modelPortDtoList
    }
})


//删除模型设备
export const delModelEquip = (cloudConfigId,id) => axios({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: '/model/device/delete',
    method: 'post',
    data: 'cloudConfigId=' + cloudConfigId + '&id=' + id
})


//修改模型设备
export const editModelEquip = (cloudConfigId,modelId,port,id) => axios({
    url: '/model/device/update',
    method: 'post',
    data: {
        "cloudConfigId": cloudConfigId,
        "modelId": modelId,
        "port": port,
        'id': id
    }
})

//设备信息
export const deviceInfo = (cloudConfigId) => axios({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: '/cloudDeviceMeta/findAllDeviceNameInfo',
    method: 'post',
    data: 'cloudConfigId=' + cloudConfigId
})


//设备库模型管理
//列表
export const modelManageList = (data,that)=>axios({
    url: '/deviceLibrary/pageList',
    method: 'post',
    data:data,
    timeout: 2000,
    cancelToken: new axios.CancelToken(function executor(c) { // 设置 cancel token
      that.source = c;
    }) 
})


//新增
export const add_modelManage = (data) => axios({
    url: '/deviceLibrary/add',
    method: 'post',
    data: data
})

//删除设备库设备
export const del_modelManage = (cloudConfigId,id) => axios({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: '/deviceLibrary/delete',
    method: 'post',
    data: "cloudConfigId="+cloudConfigId+"&id="+id
})

//修改设备库设备
export const edit_modelManage = (data) => axios({
    url: '/deviceLibrary/update',
    method: 'post',
    data: data
})

//固件管理
//表格数据
export const firmwareData = (data) => axios({
    url: '/softwareVersion/list',
    method: 'post',
    data: data
})

//新增
export const addFirmware = (data) => axios({
    headers: {
        // 'Content-Type': 'multipart/form-data'
        'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq'
    },
    url: '/softwareVersion/add',
    method: 'post',
    data: data
})

//修改
export const editFirmware = (data) => axios({
    headers: {
        // 'Content-Type': 'multipart/form-data'
        'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq'
    },
    url: '/softwareVersion/update',
    method: 'post',
    data: data
})

//删除
export const delFirmware = (id) => axios({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: '/softwareVersion/delete',
    method: 'post',
    data: "id="+id
})



// WEBPACK FOOTER //
// ./src/api/index.js